import React from "react";

export function Table({ children = undefined, className = undefined, style = undefined }) {
  return (
    <table className={className} style={style}>
      {children}
    </table>
  );
}
export function Thead({ children = undefined, className = undefined, style = undefined }) {
  return (
    <thead className={className} style={style}>
      {children}
    </thead>
  );
}
export function Tbody({ children = undefined, className = undefined, style = undefined }) {
  return (
    <tbody className={className} style={style}>
      {children}
    </tbody>
  );
}
export function Th({ children = undefined, className = undefined, style = undefined }) {
  return (
    <th className={className} style={style}>
      {children}
    </th>
  );
}
export function Tr({ children = undefined, className = undefined, style = undefined }) {
  return (
    <tr className={className} style={style}>
      {children}
    </tr>
  );
}
export function Td({ children = undefined, className = undefined, onClick = undefined, style = undefined }) {
  return (
    <td onClick={onClick} style={style} className={className}>
      {children}
    </td>
  );
}
